import { ActivateForm } from '@/components/auth/ActivateForm';

export default function ActivatePage() {
  return (
    <div className='bg-slate-50 flex min-h-svh flex-col items-center justify-center p-6 md:p-10'>
      <div className='w-full max-w-sm md:max-w-3xl'>
        <ActivateForm />
      </div>
    </div>
  );
}
